import dayjs from 'dayjs';

export const CHRISTMAS_YEAR = !dayjs().month() ? dayjs().year() - 1 : dayjs().year();
